export default __webpack_public_path__ + "static/media/GAP-Suche_Infografik.a22ee91c.jpg";